import type { Role } from '@volee/api-client'

// One set per menu destination, read by its route guard and by the row that leads there:
// the menu cannot offer a page its guard refuses. Each is its own decision, so each its name.
export const TEAMS_READERS: readonly Role[] = ['club', 'coach']
export const CALENDAR_READERS: readonly Role[] = ['club', 'coach']
